
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/ranking_stats",
      function () {
        return require("private-next-pages/manual/ranking_stats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/ranking_stats"])
      });
    }
  